import { createContext } from 'react';

export const PasskeyEnrollmentChromeContext = createContext(() => {});
